// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__wgwrw","notes":"Notes_notes__79rNm"};